// Port of api/fuel/app/classes/insights/players/weight.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'weight',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['weight.band'],
	detail: ['weight'],
	run: function(type, owner, userIndex, detail, filter) {
		var weights = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
		var band = (filter && filter['weight.band'] !== undefined) ? parseInt(filter['weight.band'], 10) : 0
		var limit = detail ? 250 : 5
		var players = this._data.players || []

		for (var i = 0; i < players.length; i++) {
			if (players[i].avgWeight <= 1.24) weights[0]++
			else if (players[i].avgWeight <= 1.49) weights[1]++
			else if (players[i].avgWeight <= 1.74) weights[2]++
			else if (players[i].avgWeight <= 1.99) weights[3]++
			else if (players[i].avgWeight <= 2.24) weights[4]++
			else if (players[i].avgWeight <= 2.49) weights[5]++
			else if (players[i].avgWeight <= 2.74) weights[6]++
			else if (players[i].avgWeight <= 2.99) weights[7]++
			else if (players[i].avgWeight <= 3.24) weights[8]++
			else if (players[i].avgWeight <= 3.49) weights[9]++
			else if (players[i].avgWeight <= 3.74) weights[10]++
			else if (players[i].avgWeight <= 3.99) weights[11]++
			else if (players[i].avgWeight <= 4.24) weights[12]++
			else if (players[i].avgWeight <= 4.49) weights[13]++
			else if (players[i].avgWeight <= 4.74) weights[14]++
			else if (players[i].avgWeight <= 5) weights[15]++
		}

		var list = players.filter(function(player) {
			return player.avgWeight >= (1 + (band * 0.25)) && player.avgWeight <= ((1 + ((band + 1) * 0.25)) - 0.01)
		})
		var total = list.length

		list = list.slice().sort(function(a, b) { return (b.totalPlays || 0) - (a.totalPlays || 0) || (a.slug || '').localeCompare(b.slug || '') })
		if (list.length > limit) list = list.slice(0, limit)

		var finalPlayers = []
		for (var j = 0; j < list.length; j++) {
			finalPlayers.push({
				id: parseInt(list[j].id, 10) || 0,
				slug: list[j].slug,
				name: list[j].primaryName,
				username: list[j].username,
				weight: parseFloat(list[j].avgWeight) || 0,
				count: parseInt(list[j].totalPlays, 10) || 0
			})
			if (list[j].id) this._references.users.push(parseInt(list[j].id, 10))
		}

		return {
			weights: {
				data: weights,
				players: finalPlayers,
				total: total
			}
		}
	}
})
